import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SelectionCoveragesService {
  constructor(private readonly http: HttpClient) {}
  getSelectionData(): Observable<any> {
    return this.http.get('assets/data/pip/selection.json');
  }
  getGarageStatesData(): Observable<any> {
    return this.http.get('assets/data/pip/garage-states.json');
  }
}
